'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('app:customer:actions');
var customerService = abp.services.api.customerB2c;

var actions = {
    loadContact: function loadContact() {
        return function (dispatch) {
            customerService.getContactInfo().done(function (c) {
                dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: toClientModel(c) });
            }).fail(function (err) {
                log('loadContact failed. %o', err);
            });
        };
    },
    changeDeliveryAddress: function changeDeliveryAddress(id) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.DELIVERY_ADDRESS_CHANGE, id: id });
            customerService.setDeliveryAddress(id).done(function () {
                return dispatch(actions.loadContact());
            });
        };
    }
};

_actions2.default.add('customer', actions);

exports.default = actions;


function toClientModel(model) {
    var invoicingAddress = model.invoicingAddress,
        deliveryAddressId = model.deliveryAddressId,
        companyNumber = model.companyNumber,
        vatNumber = model.vatNumber,
        rest = (0, _objectWithoutProperties3.default)(model, ['invoicingAddress', 'deliveryAddressId', 'companyNumber', 'vatNumber']);

    var _ref = invoicingAddress || {},
        companyName = _ref.companyName;

    return (0, _extends3.default)({}, (0, _pickBy2.default)((0, _extends3.default)({}, invoicingAddress || {}, rest, {
        deliveryAddressId: deliveryAddressId,
        companyName: companyName,
        companyNumber: companyNumber,
        vatNumber: vatNumber,
        companyIsFilledIn: !!(companyName || companyNumber || vatNumber),
        useCustomDeliveryAddress: !!deliveryAddressId
    })));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customer/actions.js
// module id = 1155
// module chunks = 0